function createParseDurationCache() {
  const parseCache = /* @__PURE__ */ new Map();
  function createCacheKey(displayValue, format) {
    return `${displayValue}:${format}`;
  }
  function getValue(displayValue, format) {
    const cacheKey = createCacheKey(displayValue, format);
    if (parseCache.has(cacheKey)) {
      const cachedResult = parseCache.get(cacheKey);
      if (cachedResult) return cachedResult;
    }
  }
  function reset() {
    parseCache.clear();
  }
  function setValue(displayValue, format, result) {
    const cacheKey = createCacheKey(displayValue, format);
    parseCache.set(cacheKey, result);
  }
  return {
    getValue,
    reset,
    setValue
  };
}
export {
  createParseDurationCache
};
//# sourceMappingURL=createParseDurationCache.js.map
